"use strict";
/**
 *
 * FormContext
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const form_1 = require("@domonda/form");
const [defaultForm] = form_1.createForm();
exports.FormContext = react_1.createContext(defaultForm);
function useFormContext() {
    return react_1.useContext(exports.FormContext);
}
exports.useFormContext = useFormContext;
